import { DEBOUNCE_DELAY_MS } from '../global-constants';
/**
 * Creates a debounced version of the provided function.
 * The debounced function delays invoking the provided function
 * until after `delay` milliseconds have elapsed since the last
 * time it was invoked.
 *
 * @param {Function} fn - The function to debounce.
 * @param {number} delay - The number of milliseconds to delay.
 * @returns {{ run: Function, cancel: Function }} An object with:
 *   - `run`: Schedules the debounced invocation with the given arguments.
 *   - `cancel`: Cancels any pending invocation.
 */
export const debounce = (fn, delay = DEBOUNCE_DELAY_MS) => {
	let timeoutId = null;

	const cancel = () => {
		if (timeoutId !== null) {
			clearTimeout(timeoutId);
			timeoutId = null;
		}
	};

	const run = (...args) => {
		cancel();
		timeoutId = setTimeout(() => {
			fn(...args);
		}, delay);
	};

	return { run, cancel };
};
